<template>
  <el-dialog ref="activitiesEdit" title="编辑" :visible.sync="visible" width="68%">
    <el-form :model="form" ref="form" size="mini">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="活动名称：">{{ form.name }}</el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item label="活动状态：">{{ form.status }}</el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item label="创建人：">{{ form.auditorName }}</el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="创建时间：">{{ form.auditTime }}</el-form-item>
        </el-col>
      </el-row>

      <el-col>
        <el-form-item label="活动时间：">
          <avue-date
              v-model="dates"
              type="datetimerange"
              prop="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              valueFormat="yyyy-MM-dd HH:mm:ss" @change="handleSelectDate"/>
        </el-form-item>
      </el-col>

      <el-col>
        <el-form-item label="参与供应商：">{{ form.merchantName }}</el-form-item>
      </el-col>

      <el-col>
        <el-form-item label="可用线路：">{{ form.lineName }}</el-form-item>
      </el-col>

      <el-col>
        <el-form-item label="活动奖励：">
          减 <el-input v-model="form.discountsMoney" clearable style="width: 6vw"/> 元
        </el-form-item>
      </el-col>

      <el-col>
        <el-form-item label="是否可使用优惠券：">
          {{ form.isChooseCoupon === 0? '否' : '是' }}
        </el-form-item>
      </el-col>

      <el-col>
        <el-form-item label="互斥：">
          {{ form.isUserCoupon === 0? '否' : '是' }}
        </el-form-item>
      </el-col>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click="submit">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { edit } from '@/api/marketing/activities-api'
  export default {
    name: "activitiesEdit",
    data() {
      return {
        visible: false,
        dates: [],
        form: {}
      }
    },
    methods: {
      init(row) {
        this.visible = true
        this.form = row
        console.log(row)
        this.dates[0] = row.startTime
        this.dates[1] = row.endTime
      },

      handleSelectDate(val) {
        this.form.startTime = val[0]
        this.form.endTime = val[1]
      },
      cancel() {
        this.visible = false
        this.form = {}
        this.form.startTime = undefined
        this.form.endTime = undefined
      },
      submit(){
        this.form.state = 1
        edit(this.form).then(resp => {
          if (resp.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.$emit('refreshDataList')
                this.cancel()
              }
            })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
